import axios from "axios";
import authHeader from "@/services/auth-header";

const API_URL = `${process.env.VUE_APP_API_BASE_URL}/api/v2`;
const main = "BytePro";
const sub = "DocumentCategory";

class DocumentCategoryService {
  getDocumentCategories() {
    return axios
      .get(`${API_URL}/${main}/${sub}`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new DocumentCategoryService();
